import { IsFail, NewFail, NewRsRes, rzlog, RzRsRes } from "../rzcmn"





export async function FindReqFullByHeaders(rq: any, findFn: (rq: any) => Promise<RzRsRes<any>>, headers: CmHdrType[]) {
    let r = await FindReqFullAll(rq, findFn, headers);
    return r;

}
export async function FindReqFull(rq: any, findFn: (rq: any) => Promise<RzRsRes<any>>, mapFn?: (any, number) => any) {
    let r = await FindReqFullAll(rq, findFn, undefined, mapFn);
    return r;
}

export type CmHdrType = {
    key: string;
    label: string;

    fmt?: (v: any, count?: number) => string;
    viewType?: string;
    sacType?: string;
}
export async function FindReqFullAll(rq: any, findFn: (rq: any) => Promise<RzRsRes<any>>, headers?: CmHdrType[], mapFn?: (any, number) => any): Promise<RzRsRes<any>> {
    let rq0 = { ...rq, page: { skip: 0, size: 1 } };

    let r0 = await findFn(rq0)
    if (IsFail(r0)) return NewFail(r0.message);
    let ndt = []

    let pgSize = 400;
    let total = r0.total;
    let totalPage = Math.ceil((total + pgSize - 1) / pgSize);



    let count = 0;
    for (let i = 0; i < totalPage; i++) {
        let rq1 = {
            ...rq,
            page: { skip: i * pgSize, size: pgSize },
        }
        let r1 = await findFn(rq1)
        if (IsFail(r1)) break;

        let dt = r1.data;
        let data = dt || [];
        if (mapFn) data = dt?.map((el) => mapFn(el, count++)) || [];
        else if (headers) {
            data = dt?.map((el) => {
                let obj: any = {};

                headers.forEach((hdr) => {
                    //rzlog.debug('FindReqFullAll : hdr.fmt=', hdr.fmt)
                    if (hdr.fmt) {
                        let v = hdr.fmt(el, count);
                        if (hdr.key) obj[hdr.key] = v;
                    }
                    else if (hdr.key) obj[hdr.key] = el[hdr.key];
                })
                count++;
                return obj;
            }) || [];
        }

        ndt.push(...data)
    }//for

    return NewRsRes(ndt, total);

}



export type CmFindItem = {
    id: string;
    title: string;
    select?: string[];
    trans?: (v: string) => string;
}
